import { ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

type DropdownContentProps = {
  children: ReactNode;
  align?: 'left' | 'right';
  offsetY?: string;
  className?: string;
};

export const DropdownBodyContainer = ({
  children,
  align = 'left',
  offsetY = '100%',
  className,
}: DropdownContentProps) => {
  const positionClasses = align === 'right' ? 'right-0' : 'left-0';

  const mergedClassName = twMerge(
    'absolute z-50 min-w-[180px] rounded-md bg-white overflow-hidden shadow-lg',
    positionClasses,
    className,
  );

  return (
    <div
      className={mergedClassName}
      style={{
        top: offsetY,
      }}
      data-testid={'dropdown_container'}
    >
      {children}
    </div>
  );
};
